import { getStatus } from "../../lib/statuses";

export function Badge({ children, tone = "neutral", icon: Icon, className = "" }) {
  return (
    <span className={`ui-badge ui-badge--${tone} ${className}`}>
      {Icon ? <Icon size={13} /> : null}
      {children}
    </span>
  );
}

export function StatusBadge({ status, label }) {
  const definition = getStatus(status, label);
  return <Badge tone={definition.tone}>{definition.label}</Badge>;
}

export function Stars({ value = 0, editable = false, onChange, label = "商业价值" }) {
  return (
    <div className={`stars ${editable ? "stars--editable" : ""}`} aria-label={`${label} ${value} 星`}>
      {[1, 2, 3, 4, 5].map((star) => (
        <button
          type="button"
          key={star}
          disabled={!editable}
          aria-label={`设为 ${star} 星`}
          onClick={() => editable && onChange?.(star)}
          className={star <= Number(value || 0) ? "is-active" : ""}
        >
          ★
        </button>
      ))}
    </div>
  );
}
